import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { UseCase } from 'src/base/use-case'
import { MenuItemTypeModel } from 'src/domain/models/component.model'
import { ComponentsRepository } from 'src/domain/repositories/component.repository'

@Injectable()
export class GetMenuItemUseCase implements UseCase<void, MenuItemTypeModel[]> {
	constructor(private componentRepository: ComponentsRepository) {}

	execute(): Observable<MenuItemTypeModel[]> {
		return this.componentRepository.GetMenuItem()
	}
}
